/* eslint-disable */
export default {
  onSearching: 'Caricamento in corso...',
  noContacts: 'Nessun record trovato.',
} as const;

// @key: @#@"onSearching"@#@ @source: @#@"Loading..."@#@
// @key: @#@"noContacts"@#@ @source: @#@"No records found."@#@
